// extracted by mini-css-extract-plugin
export default {"container":"lh","hidden":"mh","column":"nh","headline":"oh"};